/* Little Signals moves. One shared list for the home check-in and the Classroom Check-In.
   The first move for each word is the Copy Me move. The others are from Quiet Moves.
   acts are Little Bean's actions in the rig (ls-rig.js), one per step. count: [step, from, to] counts out loud on that step. */
(function () {
  var M = {
    fast: [
      { name: 'Slow push', from: 'Copy Me', steps: ['Press your hands together', 'Push slowly while you count to five', 'Let go and feel your hands buzz'], acts: ['together', 'push', 'buzz'], count: [1, 1, 5] },
      { name: 'Push the wall', from: 'Quiet Moves', steps: ['Put both hands flat on a wall', 'Push like you are moving the house', 'Stop when your arms have had enough'], acts: ['together', 'push', 'buzz'] },
      { name: 'Stomp', from: 'Quiet Moves', steps: ['Stomp. Properly. Big feet', 'All the way across the room', 'Stop when you are done'], acts: ['stamp', 'stamp', 'notice'] },
      { name: 'Slow motion', from: 'Quiet Moves', steps: ['Move like everything is underwater', 'Slow arms. Slow legs', 'Slow turning round'], acts: ['breathe', 'together', 'notice'] }
    ],
    heavy: [
      { name: 'Wake-up shake', from: 'Copy Me', steps: ['Shake one hand, then the other', 'Shake both feet', 'Stop and notice what woke up'], acts: ['shakehands', 'shakefeet', 'notice'] },
      { name: 'Shake it out', from: 'Quiet Moves', steps: ['Shake your hands. Then your arms', 'Then a leg. Then all of you', 'Like a dog getting out of the sea'], acts: ['shakehands', 'shakefeet', 'buzz'] },
      { name: 'Ten jumps', from: 'Quiet Moves', steps: ['Stand up with room around you', 'Jump ten times. Count them out loud', 'Do three if that is enough'], acts: ['stamp', 'shakefeet', 'notice'], count: [1, 1, 10] }
    ],
    tight: [
      { name: 'Squeeze and drop', from: 'Copy Me', steps: ['Squeeze your shoulders up to your ears', 'Hold for three', 'Drop them with a big breath out'], acts: ['shrug', 'hold', 'drop'], count: [1, 1, 3] },
      { name: 'The long sigh', from: 'Quiet Moves', steps: ['Breathe in through your nose', 'Let it out through your mouth', 'As loud or as quiet as you like'], acts: ['breathe', 'drop', 'notice'] },
      { name: 'Squeeze', from: 'Quiet Moves', steps: ['Find something that squashes', 'Squeeze it and let go, over and over', 'Stop when it stops helping'], acts: ['hold', 'drop', 'hug'] },
      { name: 'Hum', from: 'Quiet Moves', steps: ['Take a breath', 'Hum until you run out', 'Then again, if you want'], acts: ['breathe', 'notice', 'breathe'] }
    ],
    steady: [
      { name: 'Notice it', from: 'Copy Me', steps: ['Feet on the floor', 'Big breath out', "I'm still here"], acts: ['stamp', 'breathe', 'hug'] },
      { name: 'Five things', from: 'Quiet Moves', steps: ['Look around the room', 'Find five things you can see', 'Two things is fine too'], acts: ['notice', 'notice', 'hug'], count: [1, 1, 5] },
      { name: 'One sound', from: 'Quiet Moves', steps: ['Stop and be still', 'Find the furthest sound you can hear', 'You do not have to name it'], acts: ['notice', 'notice', 'breathe'] },
      { name: 'Hand on chest', from: 'Quiet Moves', steps: ['Put a hand flat on your chest', 'Leave it there', 'Take it off whenever you like'], acts: ['hug', 'breathe', 'hug'] }
    ]
  };

  /* Home check-in: pick a word, show me the move, try another move. */
  function checkin(wrap, labelMove, labelBack) {
    var root = wrap && wrap.querySelector('[data-ls-checkin]');
    if (!root || root.dataset.lsMoves) return;
    root.dataset.lsMoves = '1';
    var rig = root.querySelector('[data-rig]');
    var showBtn = root.querySelector('[data-ls-showmove]');
    var buttons = root.querySelectorAll('.ls-feel');
    var panels = root.querySelectorAll('[data-panel]');
    var stage = showBtn.parentNode;
    var another = document.createElement('button');
    another.type = 'button'; another.className = 'ls-showmove ls-showmove--another'; another.hidden = true;
    another.textContent = 'Try another move';
    stage.appendChild(another);
    var current = 'steady', showing = false, idx = { fast: 0, heavy: 0, tight: 0, steady: 0 };

    function move() { return M[current][idx[current]]; }
    function fill() {
      var p = root.querySelector('[data-panel="' + current + '"]'); if (!p) return;
      var m = move();
      var name = p.querySelector('.ls-result__move'), label = p.querySelector('.ls-result__label'), list = p.querySelector('.ls-result__steps');
      if (name) name.textContent = m.name;
      if (label) label.textContent = idx[current] ? 'Another move · from ' + m.from : 'Copy Me';
      if (list) { list.innerHTML = ''; m.steps.forEach(function (s) { var li = document.createElement('li'); li.textContent = s; list.appendChild(li); }); }
    }
    function draw() {
      var m = move();
      if (window.LSRig) LSRig.set(rig, current, showing ? (m.acts[1] || m.acts[0]) : 'none');
      showBtn.textContent = showing ? labelBack : labelMove;
      showBtn.setAttribute('aria-pressed', showing ? 'true' : 'false');
      another.hidden = !showing || M[current].length < 2;
      another.textContent = 'Try another move (' + (idx[current] + 1) + ' of ' + M[current].length + ')';
    }
    function pick(s) {
      current = s; showing = false;
      root.setAttribute('data-state', s);
      buttons.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-s') === s ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== s; });
      showBtn.hidden = false;
      fill(); draw();
    }
    buttons.forEach(function (b) { b.addEventListener('click', function () { pick(b.getAttribute('data-s')); }); });
    showBtn.addEventListener('click', function () { showing = !showing; draw(); });
    another.addEventListener('click', function () { idx[current] = (idx[current] + 1) % M[current].length; showing = true; fill(); draw(); });
    draw(); showBtn.hidden = true;
    function fromHash() {
      var m = (location.hash || '').match(/^#checkin-(fast|heavy|tight|steady)$/);
      if (!m) return;
      pick(m[1]);
      wrap.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
    window.addEventListener('hashchange', fromHash);
    fromHash();
    if (!document.getElementById('ls-moves-css')) {
      var st = document.createElement('style'); st.id = 'ls-moves-css';
      st.textContent = '.ls-showmove--another{background:transparent;box-shadow:none;text-decoration:underline;text-underline-offset:3px;font-weight:500;padding:4px 10px}.ls-showmove--another:hover{background:transparent}';
      document.head.appendChild(st);
    }
  }

  window.LSMoves = { list: M, checkin: checkin };
})();
